<app-nav-admin--menu></app-nav-admin--menu>

<div class="configContent">
<h1 class="configTitle">Technical Fields</h1>

<table class="table">
  <thead>
    <tr>
      <th class="techNumber" scope="col">#</th>
      <th class="techField" scope="col">Technical Field</th>
      <th class="techDescription" scope="col">Description</th>
      
      <th class="techActions" scope="col">Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let technicalField of technicalFields; index as i">
      <td class="numberColumn">{{i + 1}}</td>
      <td class="nameColumn">{{technicalField.name}}</td>
      <td >{{technicalField.descriptionText}}</td>
      
      <td class="actionColumn">
        <button mat-icon-button (click)="editTechnicalField(i)"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button (click)="deleteTechnicalField(i)"><mat-icon>delete</mat-icon></button>
      </td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td class="addTech">
        <button mat-icon-button (click)="addTechnicalField()"><mat-icon>add</mat-icon></button>
      </td>
    </tr>
  </tbody>
</table>
<hr />

<div class="mb-5">
  <button mat-raised-button class="me-2" (click)="save()" [disabled]="!dirty">Save</button>
  <button mat-raised-button (click)="discard()" [disabled]="!dirty">Discard Changes</button>
</div>
</div>
<footer>
  <patempoFooter></patempoFooter>
</footer>
